export interface SpecsComparisonMenuItem {
  /** 产品 SKU */
  sku: string
  /** 产品 handle */
  handle: string
  /** 规格数据，key 为规格项名称，value 为规格值 */
  subTitle: Record<string, string>
}

export interface SpecsComparisonLeftMenuItem {
  /** 分类标题 */
  title: string
  /** 规格项列表 */
  subTitle: string[]
  /** 是否为产品规格 */
  isProduct?: boolean
}

export interface SpecsComparisonProps {
  data: {
    /** 左侧菜单配置 */
    LeftMenu: {
      data: SpecsComparisonLeftMenuItem[]
    }
    /** 右侧产品列表配置 */
    RightMenu: {
      menus: SpecsComparisonMenuItem[]
    }
    /** 默认选中菜单配置 */
    DefaultSelectMenu: {
      buttonText: string
    }
  }
  /** 自定义类名 */
  className?: string
}
